import type {
  GlobalStateCommandFactory,
  SocketState,
} from 'components/GlobalState/GlobalStateModel';

interface SetSocketStateCommand {
  value: SocketState;
}

export const setSocketState: GlobalStateCommandFactory<SetSocketStateCommand> =
  (cmdContext) => (command) => {
    cmdContext.updateState((draft) => {
      draft.socketState = command.value;
    });
  };
